module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/facebook-3671daa897648b05643821900527100f.svg";